import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { ifProp } from 'styled-tools';

const BG = styled.div`
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: white;
`;

const Card = styled.div`
  background: #2b6dad;
  padding: 40px;
  min-width: 300px;
  max-width: calc(100vw - 40px);
  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.2);
  border-radius: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  @media (min-width: 769px) {
    max-width: 500px;
  }
`;

const Title = styled.div`
  font-size: 20px;
  line-height: 170%;
  margin-top: 10px;
  margin-bottom: 20px;
  font-weight: 500;
  color: white;
`;

const Logo = styled.img`
  margin-bottom: 40px;
  width: 180px;
`;

const DoneImg = styled.img`
  width: 180px;
`;

const StyledLink = styled(Link)`
  color: white;
  margin-top: 20px;
  font-weight: normal;
  cursor: default;
  ${ifProp(
    'to',
    `
    text-decoration: underline;
    cursor: pointer;
  `
  )}
`;

export const S = {
  StyledLink,
  DoneImg,
  Logo,
  Title,
  Card,
  BG,
};
